import React, { useCallback, useEffect, useState } from "react";
import { Container, Grid, rem, Tabs } from "@mantine/core";
import { useStore } from "../store";
import SuperGallery from "./SuperGallery";
import BulkEditActions from "./BulkEditActions";
import GeneratorOptions from "./GeneratorOptions";
import QueueProcessor from "./QueueProcessor";
import { useSearch } from "wouter";
import { getImage } from "../api";
import { IconPalette, IconPhoto, IconVideo } from "@tabler/icons-react";
import GeneratorOptionsVideo from "./GeneratorOptionsVideo";
import { ErrorBoundary } from "@sentry/react";
import Fallback from "../_Common/Fallback";

export default function SuperGenerator() {
  const setGeneratorConfig = useStore((state) => state.setGeneratorConfig);
  const query = useSearch();

  const returnRouterParams = useCallback(() => {
    const urlSearchParams = new URLSearchParams(query);
    return Object.fromEntries(urlSearchParams);
  }, [query]);

  useEffect(() => {
    if (query) {
      let params = returnRouterParams();
      if (params.fromImageId) {
        getImage(params.fromImageId).then((data) => {
          setGeneratorConfig(data.generateConfig);
        });
      }
    } else {
      // console.debug("NO query set", query);
    }
  }, [query, returnRouterParams]);
  const iconStyle = { width: rem(12), height: rem(12) };

  return (
    <Container fluid p={0}>
      <Grid>
        <Grid.Col p={0} span={{ base: 12, sm: 6, md: 3 }}>
          <ErrorBoundary>
            <QueueProcessor />
          </ErrorBoundary>
          <Tabs defaultValue="image">
            <Tabs.List grow>
              <Tabs.Tab
                value="image"
                leftSection={<IconPhoto style={iconStyle} />}
              >
                Image
              </Tabs.Tab>
              <Tabs.Tab
                value="video"
                leftSection={<IconVideo style={iconStyle} />}
              >
                Video
              </Tabs.Tab>
              <Tabs.Tab
                value="edit"
                leftSection={<IconPalette style={iconStyle} />}
              >
                Edit
              </Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="image">
              <ErrorBoundary fallback={Fallback}>
                <GeneratorOptions />
              </ErrorBoundary>
            </Tabs.Panel>
            <Tabs.Panel value="video">
              <ErrorBoundary fallback={Fallback}>
                <GeneratorOptionsVideo />
              </ErrorBoundary>
            </Tabs.Panel>
            <Tabs.Panel value="edit">
              <ErrorBoundary fallback={Fallback}>
                <BulkEditActions />
              </ErrorBoundary>
            </Tabs.Panel>
          </Tabs>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6, md: 9 }}>
          <ErrorBoundary fallback={Fallback}>
            <SuperGallery />
          </ErrorBoundary>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
